import * as React from 'react';

import { UitkCard, UitkCardContent, UitkCardTextSegment } from 'uitk-react-cards';
import { UitkIcon } from 'uitk-react-icons';

export interface InsightsCardProps {
  children?: any;
  heading: string;
  icon?: string;
  subHeading: string;
}

export const InsightsCard: React.FunctionComponent<InsightsCardProps> = props => {
  const { children, icon, heading, subHeading } = props;

  const subHeaderClassNames = icon ? 'all-cell-fill all-x-gutter-three' : 'all-y-gutter-one';

  return (
    <UitkCard className="insights-card">
      <UitkCardContent>
        <UitkCardTextSegment className="uitk-grid">
          {icon && (
            <div className="uitk-cell all-cell-shrink ">
              <UitkIcon name={icon} className="pwa-theme--grey-700" />
            </div>
          )}
          {heading && (
            <div className="uitk-cell">
              <h3 className="uitk-type-300">{heading}</h3>
            </div>
          )}
          {subHeading && <div className={`uitk-cell uitk-type-200 ${subHeaderClassNames}`}>{subHeading}</div>}
          {children}
        </UitkCardTextSegment>
      </UitkCardContent>
    </UitkCard>
  );
};
InsightsCard.displayName = 'InsightsCard';
